import { render } from "./BackendTest.vue?vue&type=template&id=120f368a&scoped=true"
import script from "./BackendTest.vue?vue&type=script&lang=js"
export * from "./BackendTest.vue?vue&type=script&lang=js"

import "./BackendTest.vue?vue&type=style&index=0&id=120f368a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120f368a"]])

export default __exports__